export function initSplitBlocks() {
    const blocks = [].slice.apply(document.querySelectorAll('[data-block="Split"]'));
    blocks.forEach(initSplitBlockInstance);
}

/**
 *
 * @param {HTMLElement} root
 */
export function initSplitBlockInstance(root) {

    const videoId   = root.dataset.videoId,
          videoType = root.dataset.videoType;

    if (videoId) {
        if (videoType === 'youtube') {
            initYoutube();
        } else if (videoType === 'vimeo') {
            initVimeo();
        }
    }


    function initYoutube() {
        if (typeof YT === 'undefined' || typeof YT.Player === 'undefined') {
            const tag = document.createElement('script');
            tag.src = 'https://www.youtube.com/iframe_api';
            const firstScriptTag = document.getElementsByTagName('script')[0];
            firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
            window.onYouTubeIframeAPIReady = applyYoutube;
        } else {
            applyYoutube();
        }

        function applyYoutube() {
            const cover = root.querySelector('.-video-preview');
            const player = root.querySelector('.-video');

            const youtubePlayer = new YT.Player(player, {
                height: '360',
                width: '640',
                videoId: videoId,
            });

            if (cover) {
                cover.addEventListener('click', () => {
                    cover.classList.add('is--hidden');
                    youtubePlayer.playVideo();
                });
            }
        }
    }

    function initVimeo() {
        const cover = root.querySelector('.-video-preview');
        const player = root.querySelector('.-video');

        const vimeoPlayer = new Vimeo.Player(player, {
            id: player.dataset.videoId,
        });

        if (cover) {
            cover.addEventListener('click', () => {
                cover.classList.add('is--hidden');
                vimeoPlayer.play();
            });
        }
    }
}
